"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySitePapers = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 126 85",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M-2.26030918e-13,18.5069564 L63.5082646,18.5069564 L63.5082646,27.114844 L9.072,27.1139564 L9.07260923,67.554751 C9.07260923,70.0600829 7.04163647,72.0910556 4.53630461,72.0910556 C2.03097276,72.0910556 -1.85746603e-13,70.0600829 -1.78069283e-13,67.554751 L-2.26030918e-13,18.5069564 Z",
        id: "mysite-paperpath-1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-2",
        x: "11.3407615",
        y: "0",
        width: "45.3630461",
        height: "27.114844"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-3",
        x: "18.1452185",
        y: "13.557422",
        width: "45.3630461",
        height: "14.0093361"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-4",
        x: "4.27351564",
        y: "0",
        width: "36.746418",
        height: "22.7058454",
        rx: "2.29729716"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
        id: "mysite-paper-path-5",
        points: "4.55841668 4.54116908 13.6752501 4.54116908 13.6752501 13.6235072 4.55841668 13.6235072"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-6",
        x: "15.9544584",
        y: "4.54116908",
        width: "18.2336667",
        height: "2.27058454"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-7",
        x: "15.9544584",
        y: "9.08233815",
        width: "13.9601511",
        height: "2.27058454"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-8",
        x: "4.55841668",
        y: "15.8940918",
        width: "6.83762503",
        height: "2.27058454"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-9",
        x: "13.6752501",
        y: "15.8940918",
        width: "11.3960417",
        height: "2.27058454"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-paper-path-10",
        x: "27.3505001",
        y: "15.8940918",
        width: "6.83762503",
        height: "2.27058454"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-262.000000, -1044.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(262.000000, 1044.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M72.8350493,13.8516878 C64.7987118,13.5730017 57.1440008,10.9748227 49.8354155,8.13265774 C42.52683,5.29049278 35.2859169,2.14036337 27.4426112,0.634156923 C22.397158,-0.334196107 16.6272807,-0.470828226 12.562518,2.23687336 C8.64974019,4.83938991 7.38615813,9.34391229 6.70721849,13.5144451 C6.19579506,16.6591526 5.8951535,19.9610954 7.2951891,22.9019391 C8.26811399,24.9438302 9.99541626,26.6593224 11.1902168,28.6144629 C15.3448392,35.4189593 12.4105331,43.8099065 7.90423787,50.4539143 C5.79641883,53.5704279 3.34136427,56.5438029 1.71168734,59.8609273 C0.0820103575,63.1780516 -0.672366975,66.9798943 0.753184356,70.3642501 C2.16764186,73.7193277 5.53571489,76.238347 9.18446059,78.010227 C16.596218,81.6103751 25.3303547,82.6405376 33.847053,83.223935 C52.6998305,84.5154338 71.6535614,83.9558931 90.5562612,83.3963518 C97.5520014,83.1881504 104.577695,82.9788649 111.460279,81.8955675 C115.280979,81.2937353 119.225928,80.3394792 121.999374,78.0340836 C125.521651,75.1062523 126.394732,70.1538802 124.033975,66.4854165 C120.07904,60.3337176 109.132803,58.8069082 106.366013,52.2008536 C104.842837,48.5660054 106.40706,44.5169235 108.62027,41.1401582 C113.36841,33.9084154 121.327091,27.5636969 121.746436,19.2963693 C122.034874,13.6185457 118.208628,7.93204707 112.293422,5.24603312 C106.091997,2.42664019 97.4943137,2.78448622 92.919237,7.44515958 C88.2088162,12.2522246 79.9306341,14.0989269 72.8350493,13.8516878 Z",
            fill: "#E6EDFB",
            fillRule: "nonzero",
            className: "fill-primary",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(51.821824, 47.996150) scale(-1, 1) translate(-51.821824, -47.996150) translate(15.609225, 11.920569)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M0,26.8996489 L72.3648649,26.8996489 L72.3648649,67.5187486 C72.3648649,70.043964 70.3177733,72.0910556 67.7925578,72.0910556 L5.44322307,72.0910556 C2.43701398,72.0910556 1.25633285e-15,69.6540416 0,66.6478325 L0,26.8996489 L0,26.8996489 Z",
              className: "fill-primary-opa50",
              fill: "#88A9F0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary",
                fill: "#1657E2",
                xlinkHref: "#mysite-paper-path-1"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.201016",
                fill: "#000000",
                xlinkHref: "#mysite-paper-path-1"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.501748252",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-2"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary",
                fill: "#1657E2",
                xlinkHref: "#mysite-paper-path-3"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.502840909",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-3"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary",
              fill: "#1657E2",
              x: "18.1452185",
              y: "27.114844",
              width: "38.5585892",
              height: "40.220352"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#FFFFFF",
              x: "21.3206317",
              y: "8.58636727",
              width: "45.3630461",
              height: "58.7488287"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary-opa50",
              fillOpacity: "0.5",
              fill: "#C3D4F7",
              x: "25.8569363",
              y: "14.0093361",
              width: "36.2904369",
              height: "18.0765627"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary-opa50",
              fillOpacity: "0.5",
              fill: "#C3D4F7",
              x: "25.8569363",
              y: "36.6050394",
              width: "36.2904369",
              height: "4.97105474"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary-opa50",
              fillOpacity: "0.5",
              fill: "#C3D4F7",
              x: "25.8569363",
              y: "46.0952348",
              width: "36.2904369",
              height: "4.97105474"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary-opa50",
              fillOpacity: "0.5",
              fill: "#C3D4F7",
              x: "25.8569363",
              y: "55.5854303",
              width: "36.2904369",
              height: "4.97105474"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(72.649766, 25.260253)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.499289773",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-4"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#FFFFFF",
              x: "0",
              y: "0",
              width: "38.7465418",
              height: "22.7058454",
              rx: "2.29729716"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-5"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.499289773",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-5"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-6"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.499289773",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-6"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-7"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.499289773",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-7"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.499289773",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-8"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-9"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.499289773",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-9"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary-opa50",
                fill: "#88A9F0",
                xlinkHref: "#mysite-paper-path-10"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.499289773",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-paper-path-10"
              })]
            })]
          })]
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySitePapers')(IllustrationMySitePapers);